<template>
  <div class="block-head f-b-c">
    <h3 class="block-head-title" :class="icon">{{ title }} <span>{{ subtitle }}</span></h3>
    <slot>
      <ul class="f-start-c flex-1">
        <li v-for="nt in typeList" :key="nt[code]" class="fc99 mr-10" :class="{active: nt[code] === activeType}" @click="changeType(nt[code])">{{ nt[label] }}</li>
      </ul>
    </slot>
    <a v-if="!hidMoreBtn" :href="moreBtnUrl" class="more-btn" target="_blank">更多</a>
  </div>
</template>

<script>
import { SELECT_OPTION_CONFIG } from "@/utils/constant";

export default {
  name: "BlockHead",
  components: {},
  props: {
    icon: {
      type: String,
      default: "purchase"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    moreBtnUrl: {
      type: String,
      default: ""
    },
    hidMoreBtn: {
      type: Boolean,
      default: false
    },
    typeList: {
      type: Array,
      default: () => []
    },
    code: {
      type: String,
      default: SELECT_OPTION_CONFIG.CODE
    },
    label: {
      type: String,
      default: SELECT_OPTION_CONFIG.LABEL
    },
    defaultActiveType: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      activeType: ""
    };
  },
  // 监听属性 类似于data概念
  computed: {
  },
  watch: {
    defaultActiveType: {
      handler(v) {
        this.activeType = v || ""
      },
      immediate: true
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    changeType(code) {
      this.activeType = code;
      this.$emit("change", this.activeType);
    }
  }
};
</script>

<style scoped lang="scss">
.block-head{
	width: 100%;
	height: 70px;
	flex-shrink: 0;
	border-bottom: 2px solid $--color-primary;
	.block-head-title{
		// padding-left: 30px;
		font-size: 30px;
		font-weight: bold;
		color: #333;
		//background: url("@/assets/images/home/icon-purchase.png") no-repeat left center / contain;
		margin-right: 30px;
		// &.purchase{
		// 	background-image: url("@/assets/images/home/icon-purchase.png");
		// }
		// &.company{
		// 	background-image: url("@/assets/images/home/icon-company.png");
		// }
		// &.business{
		// 	background-image: url("@/assets/images/home/icon-business.png");
		// }
		// &.other{
		// 	background-image: url("@/assets/images/home/icon-other.png");
		// }
		// &.link{
		// 	background-image: url("@/assets/images/home/icon-link.png");
		// }
		// &.bidding{
		// 	background-image: url("@/assets/images/home/icon-bidding.png");
		// }
		// &.result-bulletin{
		// 	background-image: url("@/assets/images/home/icon-result-bulletin.png");
		// }
    span {
      font-weight: 400;
      font-size: 20px;
      color: #999999;
    }
	}
	ul>li{
		cursor: pointer;
		&.active{
			color: $--color-primary;
			font-weight: bold;
		}
		&:hover{
			color: $--color-primary;
		}
	}
	.more-btn{
		width: 50px;
		height: 20px;
		border: 1px solid $--color-primary;
		color: $--color-primary;
		border-radius: 9px;
		text-align: center;
		line-height: 18px;
		font-size: 12px;
    margin:25px 0 0 0;
		&:hover{
			background-color: $--color-primary;
			color: #fff;
		}
	}
}
</style>
